module.exports = __webpack_public_path__ + "img/lote-segundo.0f0af60e.jpg";